// SEO/GEO das listas de exercícios do Enem (/enem/<disciplina>/<lista>).
// Só age em rotas do classroom "enem". Nas outras (PG, turmas, murais) não põe nada e
// só remove as tags que ele mesmo criou, marcadas com data-enem-head.

export const DEX_ORIGIN = 'https://dex.descomplica.com.br';

const SLUG = /^[a-z0-9-]+$/;
const MARK = 'data-enem-head';

export interface RouteLike {
	name?: string | null;
	params: { [key: string]: string | undefined };
}

// URL canônica da lista, só quando a entrada é a própria lista (rota "list").
// Questão, explicação, resultado e vídeo ficam sem canonical, como hoje.
export function enemListCanonical(route: RouteLike): string | null {
	if (!route || route.name !== 'list') return null;
	const { classroom, board, list } = route.params || {};
	if (classroom !== 'enem' || !board || !list) return null;
	if (!SLUG.test(board) || !SLUG.test(list)) return null;
	return `${DEX_ORIGIN}/enem/${board}/${list}`;
}

function removeOwn(doc: Document) {
	doc.querySelectorAll(`[${MARK}]`).forEach(el => el.parentNode && el.parentNode.removeChild(el));
}

function add(doc: Document, tag: string, attrs: { [key: string]: string }) {
	const el = doc.createElement(tag);
	Object.keys(attrs).forEach(k => el.setAttribute(k, attrs[k]));
	el.setAttribute(MARK, '');
	doc.head.appendChild(el);
}

export function applyEnemHead(
	doc: Document,
	route: RouteLike,
	title: string,
	description: string
): string | null {
	removeOwn(doc);
	const canonical = enemListCanonical(route);
	if (!canonical) return null;
	// Não duplica um canonical que já exista (ex.: vindo do HTML pré-gerado).
	doc.querySelectorAll('link[rel="canonical"]').forEach(el => el.parentNode && el.parentNode.removeChild(el));
	add(doc, 'link', { rel: 'canonical', href: canonical });
	add(doc, 'meta', { property: 'og:url', content: canonical });
	add(doc, 'meta', { property: 'og:type', content: 'website' });
	if (title) add(doc, 'meta', { property: 'og:title', content: title });
	if (description) add(doc, 'meta', { property: 'og:description', content: description });
	return canonical;
}
